<template>
  <table class="offer-selector">
    <thead v-if="offers.length === 0">
      <tr>
        <th>Brak ofert spełniających kryteria wyszukiwania</th>
      </tr>
    </thead>
    <thead v-if="offers.length > 0">
      <tr>
        <th>Przelot</th>
        <th>Terminy</th>
        <th>Pobyt</th>
        <th>Pokoje</th>
        <th>Wyżywienie</th>
        <th>Cena</th>
        <th />
      </tr>
    </thead>
    <tbody v-if="offers.length > 0">
      <tr v-for="offer in offers" :key="offer.Id" class="offer-selector__offer" :class="{
        'offer-selector__offer--selected': offer.selected,
      }">
        <td>
          <div class="offer-selector__departure">
            <Icon icon="plane" class="offer-selector__departure-icon" />
            {{ offer.FlightFrom }} / {{ offer.ParsedDepartureTime }}
          </div>
          <div class="offer-selector__arrival">
            <Icon icon="plane" class="offer-selector__arrival-icon" />
            {{ offer.ReturnFlightTo }} / {{ offer.ParsedReturnArrivalTime }}
          </div>
        </td>
        <td>
          <div>{{ offer.ParsedTripDepartureDateWithDays }}</div>
          <div>{{ offer.ParsedTripArrivalDateWithDays }}</div>
        </td>
        <td class="offer-selector__duration">{{ offer.Duration }} dni</td>
        <td>{{ offer.DescriptionOfRoom }}</td>
        <td>{{ offer.BoardStandardDesc }}</td>
        <td class="offer-selector__price">
          <span class="offer-selector__price-value">{{ offer.AdultPriceInt }}</span>
          <span class="offer-selector__price-suffix"> zł/ 1 os</span>
        </td>
        <td>
          <a :href="offer.HotelUrl + offer.Id + offer.FilterData"
              class="btn-cta btn-cta--arrow btn-cta--primaryblue">
            Wybierz
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Icon from '@/components/Icon'

@Component({
  components: {
    Icon,
  },
  props: {
    offers: {
      required: true,
      type: Array,
    },
  },
})
export default class OfferSelector extends Vue {
}
</script>

<style lang="scss">
.offer-selector {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  
  thead {
    background-color: #eee;
    tr {
      border-top: 1px solid #adadad;
      border-bottom: 1px solid #adadad;
    }
    th {
      padding: 10px 13px;
      color: #787878;
      font-size: 1.2rem;
      font-family: Gotham;
      font-weight: 500;
      font-style: normal;
      text-transform: uppercase;
    }
    th:first-child {
      padding-left: 27px;
    }
  }

  tbody {
    background-color: white;
    text-transform: none;

    td {
      color: #535353;
      font-size: 1.2rem;
      font-family: 'Gotham Book';
      font-weight: 400;
      font-style: normal;
      padding: 8px 13px;
      border-bottom: 1px solid #adadad;
    }

    td:first-child {
      padding-left: 27px;
    }
    td:last-child {
      padding-right: 27px;
      text-align: right;
    }
  }

  &__departure {
    position: relative;
  }
  &__departure-icon {
    color: #009fe9;
  }
  &__arrival-icon {
    color: #005ca9;
    &::before {
      display: inline-block;
      transform: rotate(90deg);
    }
  }

  &__duration {
    text-transform: uppercase;
  }

  &__price {
    text-transform: uppercase;
  }

  &__price-value {
    color: #005ca9;
    font-family: Gotham;
    font-weight: 700;
    font-style: normal;
    font-size: 1.6rem;
  }
  &__price-suffix {
    color: #005ca9;
    font-family: Gotham;
    font-weight: 700;
    font-style: normal;
    font-size: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offers-list/OfferSelector.vue